import React, { useState } from 'react';
import { FaRegWindowClose } from "react-icons/fa";
import {
    Button,
    Modal,
    message
} from 'antd';
// import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import axios from '../../../config/axios';

function CancelOrder({ order }) {
    const redirect = useNavigate();
    const [messageApi, contextHolder] = message.useMessage();
    const [open, setOpen] = useState(false);

    const onCancelOrder = async () => await axios.get(`/api/orders/cancledOrder/${order._id}`)
        .then(res => {
            setOpen(false)

            messageApi.open({
                type: 'success',
                content: 'Update successfully',
                duration: 1,
                onClose: () => redirect('/admin/orders')
            });
        })
        .catch(err => {
            console.log(err)
            messageApi.open({
                type: 'error',
                content: 'Update failed!',
            })
        });

    const onCancelCreate = () => {
        setOpen(false);
    }
    // console.log('order : ', order);

    return (
        <div>
            {contextHolder}
            <Button
                danger
                type='primary'
                icon={<FaRegWindowClose />}
                onClick={() => setOpen(true)}
            >Cancel</Button>
            <Modal
                open={open}
                title={`Order no. : ${order.order_no}`} onCancel={onCancelCreate}
                footer={[
                    <Button key="back" onClick={onCancelCreate}>
                        Cancel
                    </Button>,
                    <Button key="submit" type="primary" disabled={false} onClick={onCancelOrder}>
                        Ok
                    </Button>
                ]}
            >
                Do you want to change order status to "CANCEL" ?
            </Modal>
        </div>
    )
}

export default CancelOrder